export enum TransferOrderKind {
  Shipment = "shipment",
  Simple = "simple",
}
